export default [
  {
    name: 'Home',
    icon: 'menu-icon lnr lnr-home',
    route: '/'
  },
  {
    name: 'About Me',
    icon: 'menu-icon lnr lnr-user',
    route: '/about'
  },
  {
    name: 'Resume',
    icon: 'menu-icon lnr lnr-graduation-hat',
    route: '/resume'
  },
  {
    name: 'Portfolio',
    icon: 'menu-icon lnr lnr-briefcase',
    route: '/portfolio'
  },
  {
    name: 'Blog',
    icon: 'menu-icon lnr lnr-book',
    route: '/blog'
  },
  {
    name: 'Contact',
    icon: 'menu-icon lnr lnr-envelope',
    route: '/contact'
  }
]
